import { useEffect, useMemo, useState } from "react";

const PRESS_PATTERN = [0, 2, 4, 7];

function toggleTile(board, index) {
  const row = Math.floor(index / 3);
  const column = index % 3;
  const next = [...board];

  [index, index - 3, index + 3, index - 1, index + 1].forEach((tile) => {
    if (tile < 0 || tile > 8) return;
    const tileRow = Math.floor(tile / 3);
    const tileColumn = tile % 3;
    if (Math.abs(tileRow - row) + Math.abs(tileColumn - column) <= 1) {
      next[tile] = !next[tile];
    }
  });

  return next;
}

function createBoard() {
  return PRESS_PATTERN.reduce(
    (board, index) => toggleTile(board, index),
    Array(9).fill(false)
  );
}

function EasterEgg({ open, onClose }) {
  const initialBoard = useMemo(createBoard, []);
  const [board, setBoard] = useState(initialBoard);
  const [moves, setMoves] = useState(0);
  const solved = moves > 0 && board.every((tile) => !tile);

  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onClose]);

  const reset = () => {
    setBoard(initialBoard);
    setMoves(0);
  };

  const play = (index) => {
    if (solved) return;
    setBoard((current) => toggleTile(current, index));
    setMoves((current) => current + 1);
  };

  if (!open) return null;

  return (
    <div className="puzzle-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="puzzle" role="dialog" aria-modal="true" aria-labelledby="puzzle-title">
        <button className="puzzle-close" onClick={onClose} aria-label="Close puzzle" autoFocus>×</button>
        <p className="puzzle-kicker">You found it</p>
        <h2 id="puzzle-title">A small detour.</h2>
        <p className="puzzle-instructions">Turn every tile dark. Each move flips the tiles beside it.</p>
        <div className={`puzzle-grid${solved ? " is-solved" : ""}`} aria-label="Lights Out puzzle">
          {board.map((active, index) => (
            <button
              className={`puzzle-tile${active ? " is-active" : ""}`}
              key={index}
              onClick={() => play(index)}
              aria-label={`Tile ${index + 1}${active ? ", lit" : ", dark"}`}
            />
          ))}
        </div>
        {solved ? (
          <p className="puzzle-result"><strong>Solved in {moves} moves.</strong><br/>Edward’s official 3×3 record is 9.94 seconds.</p>
        ) : (
          <div className="puzzle-footer"><span>{moves} {moves === 1 ? "move" : "moves"}</span><button onClick={reset}>Reset</button></div>
        )}
      </section>
    </div>
  );
}

export default EasterEgg;
